// extracted by mini-css-extract-plugin
export var btn = "B_mz q_rx q_rg d_by d_bN d_bC d_dv";
export var full = "B_tT d_v d_G";